var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBreadcrumbs = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87707 19.3847C3.60014 19.3847 3.41553 19.2001 3.41553 18.9232V5.03087C3.41553 4.75395 3.60014 4.56934 3.87707 4.56934H7.61553C7.80014 4.56934 8.03091 4.66164 8.16937 4.80011L13.5232 11.5386C13.7078 11.7693 13.7078 12.1386 13.5232 12.4155L8.12322 19.154C7.98476 19.3386 7.75399 19.4309 7.52322 19.4309L3.87707 19.3847Z",
    fill: "#131A2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4461 11.5385L15.0461 4.84618C14.8154 4.56926 14.4 4.47695 14.0769 4.75388L13.0154 5.6308C12.6923 5.86157 12.6461 6.32311 12.923 6.60003L17.3077 12L12.923 17.4462C12.6923 17.7231 12.7384 18.1846 13.0154 18.4154L14.0769 19.2923C14.4 19.5231 14.7692 19.477 15.0461 19.2L20.4461 12.4616C20.6307 12.0923 20.6307 11.7693 20.4461 11.5385Z",
    fill: "#131A2C"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBreadcrumbs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/breadcrumbs.93aba174.svg";
export { ForwardRef as ReactComponent };